import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import InputWithOptions from '../InputWithOptions/InputWithOptions';
import Input from '../Input';
import styles from './MultiSelectCheckbox.scss';
import ListItemSelect from '../ListItemSelect';
import ListItemSection from '../ListItemSection';
var OPEN_DROPDOWN_CHARS = ['Enter', 'ArrowDown', 'Space', ' '];

var MultiSelectCheckbox = /*#__PURE__*/function (_InputWithOptions) {
  _inherits(MultiSelectCheckbox, _InputWithOptions);

  var _super = _createSuper(MultiSelectCheckbox);

  function MultiSelectCheckbox() {
    _classCallCheck(this, MultiSelectCheckbox);

    return _super.apply(this, arguments);
  }

  _createClass(MultiSelectCheckbox, [{
    key: "wrapOptionsWithCheckbox",
    value: function wrapOptionsWithCheckbox(options) {
      var _this = this;

      return options.map(function (option) {
        if (option.value === '-') {
          return _objectSpread(_objectSpread({}, option), {}, {
            overrideStyle: true,
            value: /*#__PURE__*/React.createElement(ListItemSection, {
              type: "divider"
            })
          });
        } else {
          return _objectSpread(_objectSpread({}, option), {}, {
            overrideStyle: true,
            value: function value(props) {
              return /*#__PURE__*/React.createElement(ListItemSelect, {
                checkbox: true,
                selected: _this.isSelectedId(option.id),
                disabled: option.disabled,
                title: option.value,
                highlighted: props.hovered,
                prefix: option.prefix,
                suffix: option.suffix,
                ellipsis: option.ellipsis,
                onClick: function onClick(e) {
                  return e.preventDefault();
                } // This is prevented because there's an event listener wrapping the option

              });
            }
          });
        }
      });
    }
  }, {
    key: "isSelectedId",
    value: function isSelectedId(optionId) {
      return this.props.selectedOptions.indexOf(optionId) !== -1;
    }
  }, {
    key: "dropdownAdditionalProps",
    value: function dropdownAdditionalProps() {
      return {
        options: this.wrapOptionsWithCheckbox(this.props.options),
        closeOnSelect: false,
        selectedHighlight: false
      };
    }
  }, {
    key: "selectedOptionsToText",
    value: function selectedOptionsToText() {
      var _this2 = this;

      return this.props.selectedOptions.map(function (selectedOption) {
        return _this2.props.options.find(function (option) {
          return option.id === selectedOption;
        });
      }).filter(function (selectedOption) {
        return selectedOption;
      }).map(this.props.valueParser).join(this.props.delimiter);
    }
  }, {
    key: "inputAdditionalProps",
    value: function inputAdditionalProps() {
      return {
        readOnly: false,
        disableEditing: true,
        inputElement: /*#__PURE__*/React.createElement(Input, {
          textOverflow: "ellipsis",
          disableEditing: true
        }),
        value: this.selectedOptionsToText()
      };
    }
  }, {
    key: "inputClasses",
    value: function inputClasses() {
      return styles.showPointer;
    }
  }, {
    key: "_onSelect",
    value: function _onSelect(option) {
      this.showOptions();

      if (this.closeOnSelect()) {
        this.setState({
          showOptions: false
        });
      } // The option object is not the original since it was injected a checkbox


      var originalOption = this.props.options.find(function (op) {
        return option.id === op.id;
      });

      if (this.isSelectedId(originalOption.id)) {
        this.props.onDeselect && this.props.onDeselect(originalOption.id, originalOption);
      } else {
        this.props.onSelect && this.props.onSelect(originalOption.id, originalOption);
      }
    }
  }, {
    key: "_onInputClicked",
    value: function _onInputClicked(event) {
      this.state.showOptions ? this.hideOptions() : this.showOptions();

      if (this.props.onInputClicked) {
        this.props.onInputClicked(event);
      }
    }
  }, {
    key: "_onKeyDown",
    value: function _onKeyDown(event) {
      if (OPEN_DROPDOWN_CHARS.includes(event.key)) {
        event.preventDefault();
        this.showOptions();
      }

      this.dropdownLayout && this.dropdownLayout._onKeyDown(event);
    }
  }, {
    key: "_onFocus",
    value: function _onFocus(e) {
      if (this.props.disabled) {
        return;
      }

      this._focused = true;
      this.setState({
        isEditing: false
      });

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }]);

  return MultiSelectCheckbox;
}(InputWithOptions);

MultiSelectCheckbox.displayName = 'MultiSelectCheckbox';
MultiSelectCheckbox.propTypes = _objectSpread(_objectSpread({}, InputWithOptions.propTypes), {}, {
  /** Array of objects. Objects must have an Id and can can include *value* and *node*. If value is '-', a divider will be rendered instead. */
  options: PropTypes.array,

  /** The selected options ids. */
  selectedOptions: PropTypes.array,

  /** A callback function called whenever the user selects a single option. The function receives the id of the selected option as the first argument, and the actual option object as the second argument.. */
  onSelect: PropTypes.func,

  /** A callback function to be called when an option was unchecked. The function receives the id of the unselected option as the first argument, and the actual option object as the second argument. */
  onDeselect: PropTypes.func,

  /** delimiter between the selected options that will be displayed in the input. */
  delimiter: PropTypes.string
});
MultiSelectCheckbox.defaultProps = _objectSpread(_objectSpread({}, InputWithOptions.defaultProps), {}, {
  delimiter: ', ',
  selectedOptions: [],
  closeOnSelect: false
});
export default MultiSelectCheckbox;